import { push } from "connected-react-router"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import {
    decodeFilterAndSort,
    FilterAndSortExpression
} from "../Models/Client/FilterAndSortExpression"
import { SortExpression } from "../Models/Client/SortExpression"

export function useDecodeFilterAndSort<T>(
    search: string,
    defaultSort: SortExpression<T>,
    redirectPath: string
): FilterAndSortExpression<T> {
    const dispatch = useDispatch()
    const decoded = useMemo(
        () => decodeFilterAndSort(new URLSearchParams(search), defaultSort),
        [defaultSort, search]
    )

    useEffect(() => {
        if (decoded.isError) {
            dispatch(push(redirectPath))
        }
    }, [decoded.isError, dispatch, redirectPath])

    return decoded.isError ? { filter: [], sort: defaultSort } : decoded.value
}
